<template>
  <div v-if="videoData" :style="{height: videoData.poster.height}" class="width-100" ref="videoBox">
    <div v-if="deviceName === 'Android' && isWeixin"
         class="width-100 height-100-percent position-relative overflow-hidden">
      <video-android :videoData="videoData"/>
    </div>
    <div v-else @click="playClick" class="width-100 height-100-percent overflow-hidden">
      <video-player class="vjs-custom-skin width-100 height-100-percent"
                    ref="videoPlayer"
                    :options="playerOptions"
                    :playsinline="true"
                    preload="auto"
                    x5-video-player-type="h5"
                    @play="onPlayerPlay($event)"
                    @pause="onPlayerPause($event)"
                    @ended="onPlayerEnded($event)"
                    @loadeddata="onPlayerLoadeddata($event)"
                    @waiting="onPlayerWaiting($event)"
                    @playing="onPlayerPlaying($event)"
                    @timeupdate="onPlayerTimeupdate($event)"
                    @canplay="onPlayerCanplay($event)"
                    @canplaythrough="onPlayerCanplaythrough($event)"
                    @ready="playerReadied"
                    @statechanged="playerStateChanged($event)">
      </video-player>
    </div>
  </div>
</template>

<script>
  import VideoAndroid from './VideoAndroid.vue';

  export default {
    props: ['videoData'],
    components: {VideoAndroid},
    data() {
      return {
        playerOptions: {
          height: '100%',
          controls: false,
          autoplay: false,
          muted: true,
          loop: false,
          language: 'zh-cn',
          userActions: {
            doubleClick: false,
          },
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          html5: {hls: {withCredentials: false}},
          sources: [{
            withCredentials: false,
            type: 'video/mp4',
            src: this.videoData.video[0].src,
          }],
          poster: this.videoData.poster.src,
        },
        deviceName: '',
        isWeixin: false,
      };
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player;
      },
    },
    created() {
      this.deviceName = this.$store.getters.deviceName;
      this.isWeixin = (() => {
        return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
      })();
    },
    methods: {
      playClick() {
        this.player.pause();
      },
      // listen event
      onPlayerPlay(player) {
        // console.log('player play!', player)
        player.play();
      },
      onPlayerPause(player) {
        // console.log('player pause!', player)
        player.pause();
      },
      onPlayerEnded(player) {
        // console.log('player ended!', player)
        player.currentTime(0);
      },
      onPlayerLoadeddata(player) {
        // console.log('player Loadeddata!', player)
      },
      onPlayerWaiting(player) {
        // console.log('player Waiting!', player)
      },
      onPlayerPlaying(player) {
        // console.log('player Playing!', player)
      },
      onPlayerTimeupdate(player) {
        // console.log('player Timeupdate!', player.currentTime())
      },
      onPlayerCanplay(player) {
        // console.log('player Canplay!', player)
      },
      onPlayerCanplaythrough(player) {
        // console.log('player Canplaythrough!', player)
      },
      playerStateChanged(playerCurrentState) {
        // console.log('player current update state', playerCurrentState)
      },
      playerReadied(player) {
        //
        player.currentTime(0);
      },
    },
  };
</script>
<style lang="scss">
  @import "../../assets/video/video";
</style>